import SASS from '@dui/helpers/sass';

export default {
  data: () => ({
    isMobile: false,
  }),
  beforeDestroy() {
    this.removeMobileEventListeners();
  },
  mounted() {
    this.addMobileEventListeners();
    this.checkMobileBreakpoint();
  },
  methods: {
    addMobileEventListeners() {
      window.addEventListener('resize', this.checkMobileBreakpoint);
    },

    checkMobileBreakpoint() {
      const isMobile = (window.innerWidth < SASS.menuBreakpoint.md);

      if (this.isMobile === isMobile) {
        return;
      }

      this.$set(this, 'isMobile', isMobile);
    },

    removeMobileEventListeners() {
      window.removeEventListener('resize', this.checkMobileBreakpoint);
    },
  },
};
